export default {
  SET_DEALER: (state, data) => {
    state.dealer = data;
  },
  SET_DEALERS: (state, data) => {
    state.dealers = data;
  },
};
